// extracted by mini-css-extract-plugin
module.exports = {"topSection":"top-section_topSection__2Ao8I"};